export default "__VITE_ASSET__Dsh$BNvi__";